// Third-party
import React from 'react';

// Components
import WarningModal from './WarningModal';

// Utils
import { formatMessage } from '../../../utils/i18n';

type Props = {
  show?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const DiscardPortfolioHoldingsModal = (props: Props) => {
  const body = <p>{formatMessage('DiscardPortfolioHoldings.Body')}</p>;

  return (
    <WarningModal show={props.show} onCancel={props.onCancel} onConfirm={props.onConfirm} title={formatMessage('DiscardPortfolioHoldings.Title')} body={body} />
  );
};

export default DiscardPortfolioHoldingsModal;
